import MolGrid, { Column } from "@moltech/molui/molgrid";
import React, { useRef, useState } from "react";
import RadioButton from "../../../../../../components/ui/inputs/radioButton/RadioButton";
import Checkbox from "../../../../../../components/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";


const instrumentTypeOptions = [
  { label: "Overdue/Current", value: "Overdue/Current" },
  { label: "Upcoming", value: "Upcoming" },
  { label: "Future", value: "Future" },
  { label: "All Others", value: "All Others" },
];

const CreateInvoices = () => {
  const gridRef = useRef();
  const [selectedRadioOption, setSelectedRadioOption] = useState();
  const [isSelectChecked, setIsSelectChecked] = useState(false);
  
  const handleRadioChange = (e) => {
    setSelectedRadioOption(e.target.value);
  };

  const handleCheckboxChange = () => {
    setIsSelectChecked(!isSelectChecked);
  };

  return (
    <>
      <CardSection>
        <div className="create-invoice-detail">
          <div className="radio-selection-section">
            <div className="radio-box-part">
              <RadioButton
                onChange={handleRadioChange}
                selectedOption={selectedRadioOption || "Overdue/Current"}
                options={instrumentTypeOptions}
              />
                     </div>
              <div className="check-box-sec ml-5">
                <Checkbox
                  key="expiredContracts"
                  name="expiredContracts"
                  label="Show Expired Contracts"
                  checked={isSelectChecked}
                  onChange={handleCheckboxChange}
                  // onChange={handleCheckboxChange}
                />
       
            </div>
            <div className="right-side-button-checkbox">
              <div className="btn-sec">
                <Buttons
                  buttonText={"Preview Invoices"}
                  buttonTypeClassName="btn blue-btn"
                  // onClick={() => setIsModelOpen(true)}
                />
                <Buttons
                  buttonText={"Create Invoices"}
                  buttonTypeClassName="btn blue-btn"
                  // onClick={() => setIsModelOpen(true)}
                />
              </div>
            </div>
          </div>
          <MolGrid
            ref={gridRef}
            // beforeLoad={beforeMolGridLoad}
            // afterLoad={afterMolGridLoad}
            grouping
            expandableRowGroups={true}
            paginator={false}
            scrollable
            scrollHeight="flex"
            filterDisplay="row"
            sortMode="single"
            showGridlines
            resizableColumns
            // ctxMenuItems={getCtxMenuItems}
            // onRowDoubleClick={handleRowDoubleClick}
          >
            <Column
              field="contract"
              header="Contract"
              bodyStyle={{ textAlign: "center" }}
              style={{ width: "22%" }}
              grouping
              sortable
            />
            <Column
              field="client"
              header="Client"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "22%" }}
              grouping
              sortable
            />
            <Column
              field="department"
              header="Department"
              bodyStyle={{ textAlign: "left" }}
              style={{ width: "15%" }}
              grouping
              sortable
            />
            <Column
              field="create"
              header="Create"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="installmentType"
              header="Installment Type"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="previousInvoiceDate"
              header="Previous Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="invoiceDate"
              header="Invoice Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="expirationDate"
              header="Expiration Date"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="coveragePeriod"
              header="Coverage Period"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="invoiceAmount"
              header="Invoice Amount"
              bodyStyle={{ textAlign: "Right" }}
              style={{ width: "5%" }}
              grouping
              sortable
            />
            <Column
              field="comment"
              header="Comment"
              bodyStyle={{ textAlign: "Center" }}
              style={{ width: "6%" }}
              grouping
              sortable
            />
          </MolGrid>
        </div>
      </CardSection>
    </>
  );
};

export default CreateInvoices;
